'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

interface CategoryParamsWatcherProps {
	onNavigateComplete: () => void;
}

export const CategoryParamsWatcher = ({
	onNavigateComplete,
}: CategoryParamsWatcherProps) => {
	const searchParams = useSearchParams();
	const category = searchParams.get('category');
	const page = searchParams.get('page');

	useEffect(() => {
		const timer = setTimeout(() => {
			onNavigateComplete();
		}, 800);

		return () => clearTimeout(timer);
	}, [category, page, onNavigateComplete]);

	return null;
};
